// Frontend source of truth for user types — MUST match backend VALID_USER_TYPES
export const USER_TYPES = [
  {
    value: 'public',
    label: 'Public',
    description: 'Wine lover — explore, rate, favorite, track your cellar',
    autoApproved: true,
    canCreateContent: false,
  },
  {
    value: 'private_cellar',
    label: 'Private Cellar',
    description: 'Private collector — rate wines and manage a personal cellar',
    autoApproved: false,
    canCreateContent: false,
  },
  {
    value: 'sommelier',
    label: 'Sommelier',
    description: 'Professional sommelier — curate tasting notes and ratings',
    autoApproved: false,
    canCreateContent: false,
  },
  {
    value: 'vineyard_partner',
    label: 'Vineyard Partner',
    description: 'Vineyard/producer representative — add your wines with instant publishing',
    autoApproved: false,
    canCreateContent: true,
  },
  {
    value: 'media_partner',
    label: 'Media Partner',
    description: 'Journalist or publication — contribute vineyard & wine entries (admin-reviewed)',
    autoApproved: false,
    canCreateContent: true,
  },
];

export const USER_TYPE_LABELS = Object.fromEntries(USER_TYPES.map(t => [t.value, t.label]));

export const USER_TYPE_BY_VALUE = Object.fromEntries(USER_TYPES.map(t => [t.value, t]));

export const canUserCreateContent = (user) => {
  if (!user) return false;
  if (user.is_admin) return true;
  if (user.status !== 'approved') return false;
  return USER_TYPE_BY_VALUE[user.user_type]?.canCreateContent || false;
};
